export default __webpack_public_path__ + "static/media/star-icon.45510d32.svg";